import { InitOptions } from '@domgen/checkout-sdk-types';
import { CheckoutCustomerDetails } from '../checkout-customer/checkout-customer-details.interface';
import { CheckoutBasket } from './checkout-basket.interface';

export interface CheckoutInitialisation {
  authToken: string;
  basket?: CheckoutBasket;
  customer?: CheckoutCustomerDetails;
  proposition?: {
    type: InitOptions['proposition']['type'];
  };
}
